import { Chip } from '@mui/material'
import { COLORS } from '../../styles/variables'

type ChipStyle = { bgcolor: string; color: string; borderColor: string }

/** Прозрачный чип: чёрный текст + яркая обводка по статусу. */
const chipOutline = (borderColor: string): ChipStyle => ({
  bgcolor: 'transparent',
  color: COLORS.BLACK,
  borderColor,
})

const COMPLETED = {
  label: 'Выполнен',
  sx: chipOutline(COLORS.STOPLIGHT_GO_GREEN),
}

const AWAITING_IMPLEMENTATION = {
  label: 'Ожидает',
  sx: chipOutline(COLORS.CERULEAN),
}

type Props = {
  isCompleted: boolean
}

export function SocialOrderCompletionChip({ isCompleted }: Props) {
  const config = isCompleted ? COMPLETED : AWAITING_IMPLEMENTATION

  return (
    <Chip
      size="small"
      label={config.label}
      variant="outlined"
      sx={{
        height: 22,
        fontSize: 11,
        fontWeight: 600,
        flexShrink: 0,
        alignSelf: 'flex-start',
        ...config.sx,
      }}
    />
  )
}
